export default {
  getWallets({ commit, dispatch }) {
    return this.$api.getWallets().then((data) => {
      commit('saveWallets', data);
      commit('countBalance');
      dispatch('getWalletStats');
      return data;
    });
  },

  getWalletStats({ commit }) {
    return this.$api.getPaymentsHistorySummary().then((data) => {
      commit('saveWalletStats', data);
      return data;
    });
  },
};
